<template>
  <PreviewPane :loaded="!loading" :title="template && template.Name ? template.Name : ''">

    <template v-slot:header>
      <v-toolbar dense flat class="minitoolbar">
        <template v-if="loading">
          <v-skeleton-loader type="heading" class="mx-2" style="width: 200px;" />
        </template>
        <template v-else>
          <v-btn v-if="closePreview !== undefined" icon class="ml-n3 mr-2" small @click="closePreview()">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <h4 class="my-auto">
            <span class="primary--text mr-1">{{ template.Id }}</span>
            <span>{{ template.Name }}</span>
          </h4>

          <v-spacer />

          <v-btn color="primary" small :to="openRoute">
            <v-icon class="mr-2" size="15" v-text="'open_in_full'" />
            {{ $t('servicesystem.common_objects.commonterms.open') }}
          </v-btn>
        </template>
      </v-toolbar>
    </template>

    <template v-slot:content>
      <template v-if="error">
        <v-alert type="error" class="ma-3">
          Error loading template
        </v-alert>
      </template>

      <template v-else-if="template">
        <v-card class="ma-0 mb-3 px-3 pt-3 pb-1 rounded-0">
          <h4 class="mx-4" v-text="'Activation requirements'" />
          <template v-if="template.CheckListActivations && template.CheckListActivations.length === 0">
            <v-list-item dense style="opacity: 0.6;">
              <v-list-item-title>(No Activation Requirements)</v-list-item-title>
            </v-list-item>
          </template>
          <template v-else>
            <v-list class="py-0">
              <v-list-item v-for="activation in template.CheckListActivations" :key="activation.Id" dense>
                <v-list-item-icon class="mr-3 my-auto">
                  <v-icon size="20">
                    {{ activationTypes[activation.ActivationType] ? activationTypes[activation.ActivationType].icon :
                    'mdi-help-circle-outline'
                    }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content class="py-auto">
                  <v-list-item-title>{{ activationTypes[activation.ActivationType] ?
                    activationTypes[activation.ActivationType].text : 'Unknown Activation' }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
        </v-card>

        <v-card class="ma-6 px-2 py-5 rounded-0">
          <h4 class="mx-4 mb-1" v-text="template.Name" />
          <v-list>
            <template v-if="template.CheckListFields && template.CheckListFields.length === 0">
              <v-list-item dense style="opacity: 0.6;">
                <v-list-item-title>(No Fields)</v-list-item-title>
              </v-list-item>
            </template>
            <template v-else>
              <v-list-item v-for="field in template.CheckListFields" :key="field.Id" dense>
                <v-list-item-icon class="mr-3 my-auto">
                  <v-icon size="20">
                    {{ fieldTypes[field.Type] ? fieldTypes[field.Type].icon : 'mdi-help-circle-outline' }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content class="py-auto">
                  <v-list-item-title>{{ field.Name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </template>
    </template>
  </PreviewPane>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import PreviewPane from "@/views/layouts/PreviewPane.vue";
import CheckListConstants from "@/helpers/Constants/CheckListConstants";

export default {
  name: "PreviewCheckListTemplate",
  props: {
    id: [String, Number],
    closePreview: Function,
  },
  components: {
    PreviewPane,
  },
  mixins: [clientAPI],

  data() {
    return {
      loading: true,
      template: null,
      error: null,

      fieldTypes: CheckListConstants.fieldTypes,
      activationTypes: CheckListConstants.activationTypes,
    };
  },

  mounted() {
    this.get();
  },

  methods: {
    get() {
      this.loading = true;
      this.getCheckListTemplate(this.id)
        .then((response) => {
          this.template = response;
        })
        .catch((e) => {
          console.error(e);
          this.template = null;
          this.error = e;
        })
        .finally(() => (this.loading = false));
    },

    openInNewTab() {
      let newPageRoute = this.$router.resolve(this.openRoute);
      window.open(newPageRoute.href, "_blank");
    },
  },

  computed: {
    openRoute() {
      return { name: 'ViewCheckList', params: { templateId: this.id } };
    }
  },

  watch: {
    id: function () {
      this.get();
    },
    "$route.query.timestamp"() {
      this.get();
    },
  },
};
</script>

<style>
.listheader {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: rgba(249, 249, 249, 0.713) !important;
}
</style>